// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".910f2e416f72aeed0ff0628004d963f0e095c2c6.chunk.bundle.js";
};